import { CircularProgress } from '@mui/material';
import { MODAL_LOADER_COLOR } from '../../utils';

const LoadingInline = ({ className = 'text-center py-4', size = 24 }) => (
    <div className={className}>
        <CircularProgress size={size} style={{ color: MODAL_LOADER_COLOR }} />
    </div>
);

export default LoadingInline;
